import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AutoTagProcessService {

  constructor(private http: HttpClient) { }

  /**
   * Load JSON object from API (action codes: e83e1x, 7q0wiy, mgl3cv, z60z07, 35gc5l, hmkia6, n10cpv)
   */
  loadJsonObject(
    baseUrl: string,
    params: any,
    globalServiceWrapper: any,
    filterParams: any = null,
    rowData: any = null
  ): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    let paramsMerge = _.merge({}, filterParams || {}, params);
    paramsMerge = _.merge({}, globalServiceWrapper?.globalParams || {}, paramsMerge);
    delete paramsMerge.checkLockedbj;

    const urlEncoded = new URLSearchParams();
    Object.keys(paramsMerge).forEach(key => {
      if (paramsMerge[key] !== undefined && paramsMerge[key] !== null && paramsMerge[key] !== '') {
        urlEncoded.set(key, paramsMerge[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save Auto Tag Process - action_code: 'zfwjr9'
   * Uses application/x-www-form-urlencoded with withCredentials: true
   */
  saveAutoTag(
    baseUrl: string,
    params: any,
    globalParams: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject';

    let mergedParams = _.merge({}, globalParams || {}, filterParams || {}, params);

    mergedParams.action_code = params.action_code || 'zfwjr9';
    mergedParams.sso_id = params.sso_id;
    mergedParams.tax_year = params.tax_year;
    mergedParams.scenario = params.scenario;
    mergedParams.jcd_key = params.jcd_key;
    mergedParams.consol_group_key = params.consol_group_key;
    mergedParams.FILER_LE_KEY = params.FILER_LE_KEY;
    mergedParams.me_key = params.me_key;
    mergedParams.issue_id = params.issue_id;
    mergedParams.issue_short_desc = params.issue_short_desc;
    mergedParams.checkLockedbj = params.checkLockedbj;

    const urlEncoded = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
        urlEncoded.set(key, mergedParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Update Trans Job - action_code: 'g01dos'
   */
  updateTransJob(baseUrl: string, params: any): Observable<any> {
    const url = baseUrl + '/saveJsonObject';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
